/**
 * Created by bdickson on 15/06/2016.
 */

namespace TR {

    class BookingExtrasOption {
        model: any;
        val: any;
        group: string;
        price: number;
	    priceTotal: number;
        showTotal: boolean;
        perPerson: boolean;
        isDelta: boolean;
        priceFull?: number;
        included?: boolean;
        priceRounded?: boolean;
    }

    angular
        .module('TR')
        .directive('bookingExtrasOption', ():ng.IDirective => {
            return {
                scope: {},
                bindToController: {
                    model: '=',
                    val: '=',
                    group: '@',
                    price: '=',
                    perPerson: '=',
                    showFrom: '=',
                    showTotal: '=',
                    priceTotal: '=',
                    pricePerDay: '=',
                    isDelta: '=?',
                    priceFull: '=?',
                    included: '=?',
                    priceRounded: '=?'
                },
                controller: BookingExtrasOption,
                controllerAs: 'beo',
                templateUrl: 'partials/home/directivetemplate?type=BookingExtrasOption',
                transclude: true,
                replace: true
            };

        });

}
